jQuery(function($) {

    var initShopify = function(){
        var html = $('html, body'),
            navContainer = $('.nav-container'),
            navToggle = $('.nav-toggle');

        // Nav toggle
        navToggle.on('click', function(e) {
            var $this = $(this);
            e.preventDefault();
            $this.toggleClass('is-active');
            navContainer.toggleClass('is-visible');
            html.toggleClass('nav-open');
            $(".nav li").removeClass("hover");
        });

        var ww = document.body.clientWidth;

        var submenuclose = "//baumbad.de/cdn/shop/t/57/assets/left-sb-ar.png?v=20508898010066956321771215870";

        $('.menus ul li a.parent').after('<span class="submenu-close"><img src="'+submenuclose+'" /></span>');
        $(".nav li a").each(function() {
            if ($(this).next().length > 0) {
                  $(this).addClass("parent");
            };
        });

        var adjustMenu = function() {
            if (ww < 1024) {
                $(".nav li").unbind('mouseenter mouseleave');
                $(".nav li .submenu-close").unbind('click').bind('click', function(e) {
                    e.preventDefault();
                    $(this).parent("li").toggleClass("hover");
                });
            } else if (ww >= 1024) {
                $(".nav li").removeClass("hover");
                $(".nav li .submenu-close").unbind('click');
                $(".nav li").unbind('mouseenter mouseleave').bind('mouseenter mouseleave', function() {
                 
                //  $(this).toggleClass('hover');
                });

              $(document).ready(function() {
                $(".nav li").on("mouseenter", function() {
                  $(this).addClass("hover");
                });
                $(".nav li").on("mouseleave", function() {
                  $(this).removeClass("hover")
                });
              });
            }
        }

        adjustMenu();

        $(window).bind('resize orientationchange', function() {
            ww = document.body.clientWidth;
            adjustMenu();
        });

        $(window).scroll(function() {
            if ($(this).scrollTop() > 300) {
                $('.scroll-top').fadeIn();
                $('.header').addClass('fixed');
            } else {
                $('.scroll-top').fadeOut();
                $('.header.fixed').removeClass('fixed');
            }
        });
    }

    initShopify();

    $(document)
    .on( 'shopify:section:load', initShopify )
    .on( 'shopify:section:unload', initShopify );
});